import { render, staticRenderFns } from "./InstagramSocialIcon.vue?vue&type=template&id=77397238&"
import script from "./InstagramSocialIcon.vue?vue&type=script&lang=ts&"
export * from "./InstagramSocialIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports